import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
export enum SplashAnimationType {
  SlideLeft = 'slide-left',
  SlideRight = 'slide-right',
  FadeOut = 'fade-out'
}
@Component({
  selector: 'app-splash-screen',
  templateUrl: './splash-screen.component.html',
  styleUrls: ['./splash-screen.component.scss']
})
export class SplashScreenComponent implements OnInit {
  windowWidth: string;
  splashTransition: string;
  opacityChange = 1;
  showSplash = true;

  animationDuration = 0.5;
  duration = 3;
  animationType: 'fade-out';
  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
  ) {
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        let transitionStyle = '';
        if (this.animationType) {
          transitionStyle = 'opacity ' + this.animationDuration + 's';
          this.opacityChange = 0;
        }

        this.splashTransition = transitionStyle;

        setTimeout(() => {
          this.showSplash = !this.showSplash;
        }, this.animationDuration * 100);
      }, this.duration * 1000);
    }
  }
}
